export default __webpack_public_path__ + "static/media/closet5-before2-1920w.7b521467.avif";